module.exports = __webpack_public_path__ + "static/hotel3-ce1e32842919f86954813cbb0d9f76bb.jpg";